var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { PureComponent } from "react";
import { get, merge } from "lodash";
import client, { Query, pagination } from "@irati/utils/services/apollo";
import DealListQuery, { dealListQueryKey } from "../../services/queries/dealList";
export var query = DealListQuery;
export var queryKey = dealListQueryKey;
export function updateDealList(variables, deal) {
    var _a;
    try {
        var data = client.readQuery({ query: query, variables: variables });
        var deals = data[dealListQueryKey];
        if (deals && deals.results) {
            var cachedDeal = deals.results.filter(function (t) { return t.uuid === deal.uuid; })[0];
            var cachedDeals = __spreadArrays(deals.results);
            if (cachedDeal) {
                var index = deals.results.indexOf(cachedDeal);
                cachedDeals[index] = merge(cachedDeal, deal);
            }
            else {
                cachedDeals = __spreadArrays([deal], cachedDeals);
            }
            client.writeQuery({ query: query, variables: variables, data: (_a = {}, _a[queryKey] = __assign(__assign({}, deals), { results: cachedDeals }), _a) });
        }
    }
    catch (e) {
        console.error("[DealList]: Failed to update cache");
    }
}
export function removeFromDealList(variables, deal) {
    var _a;
    try {
        var data = client.readQuery({ query: query, variables: variables });
        var deals = data[dealListQueryKey];
        var updatedList = deals.results.filter(function (t) { return t.uuid !== deal.uuid; });
        client.writeQuery({ query: query, variables: variables, data: (_a = {}, _a[queryKey] = __assign(__assign({}, deals), { results: updatedList }), _a) });
    }
    catch (e) {
        console.error("[DealList]: Failed to update cache");
    }
}
export function getDealList(apollo) {
    var deals = get(apollo, "data[" + dealListQueryKey + "]", {});
    var _a = deals.results, results = _a === void 0 ? [] : _a, offset = deals.offset, limit = deals.limit, count = deals.count, total = deals.total;
    return {
        results: results,
        offset: offset,
        limit: limit,
        count: count,
        total: total
    };
}
var DealListComponent = /** @class */ (function (_super) {
    __extends(DealListComponent, _super);
    function DealListComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DealListComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, props = __rest(_a, ["children"]);
        return (React.createElement(Query, __assign({}, props, { query: query }), function (apollo) {
            var nextPage = function (nextPageVariables) { return pagination({ query: query, variables: nextPageVariables }, apollo); };
            return _this.props.children(__assign(__assign({}, apollo), { nextPage: nextPage }));
        }));
    };
    return DealListComponent;
}(PureComponent));
export default DealListComponent;
